import { IDimension, IPosition } from './types';

export const getZoomStyle = ({ width, height }: IDimension): React.CSSProperties => ({
  width: `${width}px`,
  height: `${height}px`,
  top: `0px`,
  left: `110px`, // padding-left(10) + image-width(image-selector)(80) + margin-right(20)
});

export const getPositionStyle = ({ top, left }: IPosition): React.CSSProperties => ({
  top: `${top}px`,
  left: `${left}px`,
});
